<app-processing [visible]="!pageVars.isReady"></app-processing>

<div class="flex justify-content-between flex-wrap">
  <div class="flex align-items-center justify-content-center">
    <p-breadcrumb [model]="pageVars.breadcrumbItems">
      <ng-template let-item let-last="last" let-first="first" pTemplate="item">
        <ng-container *ngIf="!first">
          <a *ngIf="item.routerLink" [routerLink]="item.routerLink">{{ item.label }}</a>
          <div *ngIf="!item.routerLink" class="breadcrumb-current-item">{{ item.label }}</div>
        </ng-container>
      </ng-template>
    </p-breadcrumb>
  </div>

  <div class="flex align-items-center justify-content-center">
    <p-button icon="pi pi-refresh" [raised]="true" class="mr-2" (click)="resetPage(dt)" pTooltip="Reset Table" tooltipPosition="bottom"></p-button>
    <p-button icon="pi pi-filter-slash" [raised]="true" *ngIf="filtersActive" (click)="clearFilters(dt)" pTooltip="Clear Filter/Sort" tooltipPosition="bottom"></p-button>
  </div>

  <div class="flex align-items-center justify-content-center">
    <p-button label="Add Set-Up Date" class="mr-2" [raised]="true" iconPos="right" (onClick)="addSetupDate()"
      [disabled]="selectedOrderItemInstances.length === 0"></p-button>
    <p-button label="Get Batch Recipe" class="mr-2" [raised]="true" iconPos="right" (onClick)="getBatchRecipe()"
      [disabled]="selectedOrderItemInstances.length === 0 || !isModsRecipeEnabled"
      [pTooltip]="isRecipesLookupForbidden ? 'User do not have permission for get batch recipe' : undefined"></p-button>
    <p-splitButton label="Deliver/Ship" [raised]="true" class="mr-2" [model]="deliverShipItems"
      [disabled]="selectedOrderItemInstances.length === 0"></p-splitButton>
    <p-button label="Print Labels" class="mr-2" [raised]="true" iconPos="right" (onClick)="printLabels()"
      [disabled]="selectedOrderItemInstances.length === 0"></p-button>
    <p-button class="mr-2" label="Export" [raised]="true" iconPos="right" (onClick)="exportThisList()"></p-button>
  </div>
</div>

<p-table
  #dt
  [value]="orderItemInstances"
  [columns]="cols"
  [reorderableColumns]="true"
  [resizableColumns]="true"
  columnResizeMode="expand"
  [paginator]="true"
  [first]="skip"
  [rows]="take"
  [totalRecords]="totalCount"
  [lazy]="true"
  stateStorage="local"
  stateKey="substrate-prep-table"
  (onLazyLoad)="handleTableEvents($event)"
  [(selection)]="selectedOrderItemInstances"
  dataKey="InstanceId"
  [scrollable]="true"
  scrollHeight="60vh">

  <ng-template #header let-columns>
    <tr>
      <th style="width: 3rem">
        <p-checkbox inputId="selectAll" [binary]="true" [ngModel]="selectAllToggle"
          (click)="toggleSelectAll(!selectAllToggle)"></p-checkbox>
      </th>
      <th *ngFor="let col of columns" pResizableColumn pReorderableColumn [pSortableColumn]="col.field"
        [ngStyle]="col.headerStyle || getColumnHeaderStyle(col.field)">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
        <p-columnFilter
          [type]="col.type"
          [field]="col.field"
          placeholder="Filter.."
          display="menu"
          class="ml-1"
          [matchModeOptions]="col.type === 'text' ? customMatchModeOptions : col.type === 'date' ? dateMatchModeOptions : col.type === 'numeric' ? numericMatchModeOptions : undefined">
        </p-columnFilter>
      </th>
    </tr>
  </ng-template>

  <ng-template #body let-order let-columns="columns">
    <tr>
      <td>
        <p-checkbox [value]="order" [(ngModel)]="selectedOrderItemInstances" (onChange)="selectRowClick()"></p-checkbox>
      </td>
      <td *ngFor="let col of columns" [ngStyle]="col.style">
        <ng-container [ngSwitch]="col.template">
          <a *ngSwitchCase="'link'" [routerLink]="['/orders', order.OrderId, 'substrateprep']">
            {{ order[col.field] }}
          </a>
          <div *ngSwitchCase="'variant'" style="white-space: normal; overflow-wrap: break-word; word-break: break-word">
            {{ order[col.field] }}
          </div>
          <div *ngSwitchCase="'tooltip'" [pTooltip]="order[col.field]" tooltipPosition="top" class="text-line-clamp-3">
            {{ order[col.field] }}
          </div>
          <span *ngSwitchCase="'boolean'">
            {{ order[col.field] === true ? 'Yes' : 'No' }}
          </span>
          <ng-container *ngSwitchDefault>
            {{ order[col.field] }}
          </ng-container>
        </ng-container>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="cols.length + 1">No orders found.</td>
    </tr>
  </ng-template>

</p-table>
<p-dialog
  *ngIf="showSetupDateModel"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="showSetupDateModel"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '30rem' }">
  <h4 style="font-weight: bold; margin-top: 0px">Set Up Date</h4>
  <div class="grid">
    <div class="col mb-2 mt-2">
      <div class="flex align-content-center flex-wrap w-full">
        <p-floatlabel variant="on">
          <p-datepicker class="required" id="setUpDate" [(ngModel)]="setUpDate" [showIcon]="true"
            data-testId="setUpDate" [iconDisplay]="'input'" inputId="icondisplay" appendTo="body"></p-datepicker>
          <label for="on_label">Set Up Date</label>
        </p-floatlabel>
      </div>
    </div>
  </div>
  <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
    <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="onCancelSetupDate()" data-testid="newItemCancel" />
    <p-button label="Add" icon="fa fa-check" severity="success" size="small" [raised]="true" (click)="onSaveSetupDate()" data-testid="newItemSave" />
  </div>
</p-dialog>
<p-dialog
  *ngIf="showBatchRecipeModel"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="showBatchRecipeModel"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '30rem' }">
  <h4 style="font-weight: bold; margin-top: 0px">Batch Recipe Inputs</h4>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-inputnumber [(ngModel)]="amountOfOverage" class="required" inputId="quantity" [useGrouping]="false"
          data-testid="amountOfOverage" [style]="{ width: '100%' }" />
        <label for="amountOfOverage">Overage Amount (ml)</label>
      </p-floatlabel>
    </div>
  </div>
  <p-table [value]="instancesWithNullSubstrateAmount" dataKey="id" editMode="row" class="table-sm"
    *ngIf="instancesWithNullSubstrateAmount.length > 0">
    <ng-template #header>
      <tr>
        <th>Substrate Name</th>
        <th style="width: 5rem">Substrate Amount (ml)</th>
      </tr>
    </ng-template>
    <ng-template #body let-instance let-editing="editing" let-rowIndex="rowIndex">
      <tr>
        <td>
          <div class="flex w-full">{{ instance.SubstrateName }}</div>
        </td>
        <td>
          <p-inputnumber id="SubstrateAmount" name="SubstrateAmount" [(ngModel)]="instance.SubstrateAmount"
            inputId="SubstrateAmount" attr.data-testid="SubstrateAmount{{ instance.OrderItemInstanceId }}" />
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
    <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="onCancelBatchRecipe()" data-testid="newItemCancel" />
    <p-button label="Calculate & Generate" icon="fa fa-check" severity="success" size="small" [raised]="true" (click)="onCalculateBatchRecipe()" data-testid="newItemSave" />
  </div>
</p-dialog>

<app-print-label
  [open]="showPrintModal"
  [orderItemInstanceIds]="selectedOrderItemInstanceIds"
  (close)="showPrintModal = false"
  (printed)="afterPrintLabels()">
</app-print-label>
<p-dialog
  [(visible)]="deliveryDlgVars.isVisible"
  header="Select Delivery Location"
  [modal]="true"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  appendTo="body">
  <div class="form-row">
    <p-floatLabel class="mt-1" variant="on" style="width: 100%">
      <p-treeselect
        inputId="locationId"
        [(ngModel)]="deliveryDlgVars.deliveryLocation"
        (ngModelChange)="computeDeliverDialogValidation(false)"
        [options]="deliveryDlgVars.locations"
        class="w-full required"
        containerStyleClass="w-full"
        appendTo="body">
      </p-treeselect>
      <label for="locationId">Delivery Location</label>
    </p-floatLabel>
  </div>
  <ng-template #footer>
    <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
      <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="deliveryDlgCancel()" />
      <p-button label="Save" icon="fa fa-check" severity="success" size="small" [raised]="true" (click)="deliveryDlgSave()" [disabled]="!isDeliverDialogValid" />
    </div>
  </ng-template>
</p-dialog>
<p-dialog
  [modal]="true"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="shipDlgVars.isVisible"
  [showHeader]="false"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '20rem' }">
  <div class="grid mt-2">
    <div class="col">
      <div class="flex align-content-center flex-nowrap">
        <div class="flex align-items-center justify-content-center mt-2">
          <p-floatLabel variant="on" class="w-full">
            <p-datepicker
              id="shippingDate"
              [(ngModel)]="shipDlgVars.shippingInfo.shippingDate"
              showIcon
              iconDisplay="input"
              data-testId="shippingDate"
              appendTo="body"
              class="required"
              (onSelect)="onShippingDateChange()"
              (onInput)="onShippingDateChange()"></p-datepicker>
            <label for="shippingDate">Shipping Date</label>
          </p-floatLabel>
        </div>
      </div>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <div class="flex align-content-center flex-nowrap">
        <div class="flex align-items-center justify-content-center mt-1">
          <p-floatLabel variant="on" class="w-full">
            <input pInputText type="text" [(ngModel)]="shipDlgVars.shippingInfo.shippingVendor" (ngModelChange)="onShippingVendorChange()" class="required" />
            <label for="shipper">Shipper</label>
          </p-floatLabel>
        </div>
      </div>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <div class="flex align-content-center flex-nowrap">
        <div class="flex align-items-center justify-content-center mt-1">
          <p-floatLabel variant="on" class="w-full">
            <input pInputText type="text" [(ngModel)]="shipDlgVars.shippingInfo.shippingTrackingNumber" (ngModelChange)="onShippingTrackingChange()" class="required" />
            <label for="trackingNumber">Tracking Number</label>
          </p-floatLabel>
        </div>
      </div>
    </div>
  </div>
  <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
    <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="shipDlgCancel()" />
    <p-button label="Save" icon="fa fa-check" severity="success" size="small" [raised]="true" (click)="shipDlgSave()" [disabled]="!isShipDialogValid" />
  </div>
</p-dialog>